import { inject } from '@angular/core';
import { CanActivateFn, UrlTree, Router } from '@angular/router';
import { AuthService, ADMIN_ROLE, BUSINESS_EXECUTIVE_ROLE, CUSTOMER_BASE_ACCESS_ROLE_GROUP } from '@zvoove-market/shared';

export const customerAreaRedirectGuard = (): CanActivateFn => (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const ctx = authService.$context;
  return (
    ((ctx().mandant?.roles.includes(ADMIN_ROLE) || ctx().mandant?.roles.includes(BUSINESS_EXECUTIVE_ROLE)) &&
      router.parseUrl('/customer/detail')) ||
    (ctx().mandant?.roles.some((role) => CUSTOMER_BASE_ACCESS_ROLE_GROUP.includes(role)) && router.parseUrl('/customer/appointments')) ||
    router.parseUrl('/not-found')
  );
};
